// src/pubnub/pubnub-service.ts
import Pubnub from "pubnub";
var PubnubService = class {
  constructor({ secretKey, authKey, uuid, publishKey, subscribeKey, origin }) {
    this.uuid = uuid;
    this.pubnub = new Pubnub({
      publishKey,
      subscribeKey,
      secretKey,
      authKey,
      origin,
      uuid: this.uuid,
      ssl: true
    });
  }
  async grantToken(options) {
    return this.pubnub.grantToken(options);
  }
  subscribe(params) {
    this.pubnub.subscribe(params);
  }
  async publish(params) {
    await this.pubnub.publish(params);
  }
  addListener(params) {
    this.pubnub.addListener(params);
  }
  encrypt(params) {
    const { cipherKey, clearText } = params;
    return this.pubnub.encrypt(clearText, cipherKey);
  }
  decrypt(params) {
    const { cipherKey, secureText } = params;
    return this.pubnub.decrypt(secureText, cipherKey);
  }
};

// src/pubsub/types/publish.ts
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["Success"] = "Success";
  Status2["Failure"] = "Failure";
  return Status2;
})(Status || {});
export {
  PubnubService,
  Status
};
//# sourceMappingURL=index.js.map
